import { render, staticRenderFns } from "./lstDictionary.vue?vue&type=template&id=56e62c86"
import script from "./lstDictionary.vue?vue&type=script&lang=js"
export * from "./lstDictionary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports